<template>
  <form class="form-horizontal group-border-dashed" autocomplete="off" v-if="operators">
    <div class="form-group">
      <label class="col-sm-2 control-label"><b>Оператор сбора:</b></label>
      <div class="col-sm-10">
        <!--<v-select v-if="operators.length>1" :options="operators" v-model="guestVisit.operator" label="name"-->
        <!--name="guestVisit.operator" class="select2"-->
        <!--v-validate data-vv-rules="required" data-vv-as="Оператор" disabled>-->
        <!--</v-select>-->
        <input v-if="" type="text" :value="guestVisit.operator.name"
               class="form-control input-sm disabled" disabled/>
      </div>
    </div>
    <div class="form-group" :class="{'has-error' : errors.has('guestVisit.lastName')}">
      <label class="col-sm-2 control-label"><b>Фамилия*:</b></label>
      <div class="col-sm-10">
        <input v-validate="'required|max:256'" class="form-control input-sm"
               data-vv-as="Фамилия" placeholder="Фамилия"
               :class="{'input': true, 'is-danger': errors.has('guestVisit.lastName')}"
               name="guestVisit.lastName"
               type="text" v-model="guestVisit.last_name" autocomplete="off">
        <span v-show="errors.has('guestVisit.lastName')" class="text-danger">{{ errors.first('guestVisit.lastName')
          }}</span>
      </div>
    </div>
    <div class="form-group" :class="{'has-error' : errors.has('guestVisit.firstName')}">
      <label class="col-sm-2 control-label"><b>Имя*:</b></label>
      <div class="col-sm-10">
        <input v-validate="'required|max:256'" class="form-control input-sm"
               data-vv-as="Имя" placeholder="Имя"
               :class="{'input': true, 'is-danger': errors.has('guestVisit.firstName')}"
               name="guestVisit.firstName"
               type="text" v-model="guestVisit.first_name" autocomplete="off">
        <span v-show="errors.has('guestVisit.firstName')" class="text-danger">{{ errors.first('guestVisit.firstName')
          }}</span>
      </div>
    </div>
    <div class="form-group" :class="{'has-error' : errors.has('guestVisit.middleName')}">
      <label class="col-sm-2 control-label">Отчество:</label>
      <div class="col-sm-10">
        <input v-validate="'max:256'" class="form-control input-sm"
               data-vv-as="Отчество" placeholder="Отчество"
               :class="{'input': true, 'is-danger': errors.has('guestVisit.middleName')}"
               name="guestVisit.middleName"
               type="text" v-model="guestVisit.middle_name" autocomplete="off">
        <span v-show="errors.has('guestVisit.middleName')" class="text-danger">{{ errors.first('guestVisit.middleName')
          }}</span>
      </div>
    </div>
    <div class="form-group" :class="{'has-error' : errors.has('guestVisit.date_start')}">
      <label class="col-sm-2 control-label"><b>Дата заезда*:</b></label>
      <div class="col-sm-2">
        <!--<date-picker width='150' v-model="guestVisit.date_start" :first-day-of-week="1" format="dd.MM.yyyy"-->
        <!--lang="ru" :class="{'input': true, 'is-danger': errors.has('guestVisit.date_start')}"></date-picker>-->
        <masked-input v-validate="'required|date_format:DD.MM.YYYY|after:01.05.2018'" name="guestVisit.date_start"
                      v-model.lazy="guestVisit.date_start" mask="11.11.1111"
                      class="form-control input-sm" data-vv-as="Дата заезда"
                      :class="{'input': true, 'is-danger': errors.has('guestVisit.date_start')}"/>
        <div class="small" style="color: darkgrey;">Формат: ДД.ММ.ГГГГ</div>
      </div>
      <span v-show="errors.has('guestVisit.date_start')" class="text-danger">
        <template v-if="errors.first('guestVisit.date_start')=='Поле Дата заезда должно быть в формате DD.MM.YYYY.'">
                    Поле Дата рождения должно быть в формате ДД.ММ.ГГГГ.</template>
        <template v-else>{{ errors.first('guestVisit.date_start')}}</template>
      </span>
    </div>
    <div class="form-group" :class="{'has-error' : errors.has('guestVisit.date_end')}">
      <label class="col-sm-2 control-label"><b>Дата выезда*:</b></label>
      <div class="col-sm-2">
        <masked-input v-validate="'required'"
                      name="guestVisit.date_end"
                      v-model.lazy="guestVisit.date_end" mask="11.11.1111"
                      class="form-control input-sm" data-vv-as="Дата выезда"
                      :class="{'input': true, 'is-danger': errors.has('guestVisit.date_end')}"/>
        <div class="small" style="color: darkgrey;">Формат: ДД.ММ.ГГГГ</div>
        <!--<date-picker width='150' v-model="guestVisit.date_end" :first-day-of-week="1" format="dd.MM.yyyy"-->
        <!--:not-before="guestVisit.date_start"-->
        <!--lang="ru" :class="{'input': true, 'is-danger': errors.has('guestVisit.date_end')}"></date-picker>-->
      </div>
      <span v-show="errors.has('guestVisit.date_end')" class="text-danger">
        <template v-if="errors.first('guestVisit.date_end')=='Поле Дата заезда должно быть в формате DD.MM.YYYY.'">
                    Поле Дата рождения должно быть в формате ДД.ММ.ГГГГ.</template>
        <template v-else>{{ errors.first('guestVisit.date_end')}}</template>
      </span>
    </div>
    <div class="form-group">
      <div :class="{'has-error' : errors.has('guestVisit.taxablePeriod')}">
        <label class="col-sm-2 control-label">Количество дней <span class="mdi mdi-info"
                                                                    title="Количество дней фактического проживания плательщика курортного сбора, за исключением дня заезда"></span>:</label>
        <div class="col-sm-2">
          <label class="control-label" v-if="guestVisit.taxable_period">{{guestVisit.taxable_period - 1}}</label>
        </div>
      </div>
    </div>
    <div class="form-group">
      <label class="col-sm-2 control-label">Льготная категория:</label>
      <div class="col-sm-10">
        <v-select v-model="guestVisit.privilege_category" label="name" class="select2" :options="privilegeCategories">
        </v-select>
      </div>
    </div>
    <hr>
    <div class="form-group">
      <label class="col-sm-2 control-label"><b>Отказался от оплаты сбора*:</b></label>
      <div class="col-sm-6">
        <div class="be-radio inline">
          <input type="radio" :checked="guestVisit.refusal_to_pay===false" name="refusalPay" id="false" value="false"
                 @click="guestVisit.refusal_to_pay=false">
          <label for="false">Нет</label>
        </div>
        <div class="be-radio inline">
          <input type="radio" :checked="guestVisit.refusal_to_pay===true" name="refusalPay" id="true" value="true"
                 @click="guestVisit.refusal_to_pay=true">
          <label for="true">Да</label>
        </div>
      </div>
    </div>
    <div class="form-group col-sm-12">
      <label class="col-sm-2 control-label"><h4><b>Сумма оплаты: </b></h4></label>
      <label class="col-sm-5 control-label">
    <span class="pull-left">
    <h4>
    <b v-if="guestVisit.tax_amount && guestVisit.tax_amount!==0 && !guestVisit.refusal_to_pay">{{taxAmount}} ₽</b>
    <b v-if="!guestVisit.tax_amount || guestVisit.tax_amount===0 || guestVisit.refusal_to_pay">—</b>
    </h4>
    </span>
      </label>
    </div>
  </form>
</template>

<script>
  import axios from 'axios'
  import {mapGetters} from 'vuex'
  import DatePicker from 'vue2-datepicker'
  import momment from 'moment'
  import maskedInput from 'vue-masked-input'

  export default {
    components: {DatePicker, maskedInput},
    props: [
      'guestVisit'
    ],
    created: function () {
      this.updateFieldValue()
    },
    computed: {
      taxablePeriod () {
        if (!this.errors.has('guestVisit.date_start') && !this.errors.has('guestVisit.date_end')) {
          let date_start = moment(this.guestVisit.date_end, "DD.MM.YYYY")
          let date_end = moment(this.guestVisit.date_start, "DD.MM.YYYY")
          if (date_start && date_end) {
            return date_start.diff(date_end, 'days') + 1
          }
        }
      },
      privilegeCategory () {
        return this.guestVisit.privilege_category
      },
      taxRate () {
        if (this.regions && this.guestVisit.operator) {
          let region = this.regions.find(item => Number(item.id) === Number(this.guestVisit.operator.region))
          if (region) {
            return region.tax_rate
          }
        }
      },
      taxAmount () {
        if (this.guestVisit.taxable_period && !this.guestVisit.privilege_category) {
          return (this.guestVisit.taxable_period - 1) * this.taxRate
        } else {
          return 0
        }
      },
      ...mapGetters(
        {
          privilegeCategories: 'privilegeCategories',
          operators: 'operators',
          regions: 'regions'
        }
      )
    },
    methods: {
      updateFieldValue: function () {
        this.guestVisit.date_start = moment(this.guestVisit.date_start).format('DD.MM.YYYY')
        this.guestVisit.date_end = moment(this.guestVisit.date_end).format('DD.MM.YYYY')
        if (this.guestVisit.operator) {
          this.guestVisit.operator = this.operators.find(item => Number(item.id) === Number(this.guestVisit.operator))
        }
        if (this.guestVisit.privilege_category) {
          this.guestVisit.privilege_category = this.privilegeCategories.find(item => Number(item.id) === Number(this.guestVisit.privilege_category))
        }
      },
      validate: function () {
        if (!this.errors.has('guestVisit.date_start') && !this.errors.has('guestVisit.date_end')) {
          this.$validator.validateAll().then((result) => {
            if (result) {
              this.$emit('dataIsValid')
            } else {
              this.$snotify.warning('Проверьте введенные данные!', 'Ошибка!')
            }
          }).catch(() => {
          })
        }

      },
      getDictById: function (dictName, id) {
        return dictName.find(item => item.id === id)
      }
    },
    watch: {
      taxablePeriod () {
        this.guestVisit.taxable_period = this.taxablePeriod
        this.guestVisit.tax_amount = this.taxAmount
      },
      privilegeCategory () {
        this.guestVisit.tax_amount = this.taxAmount
      },
    }
  }
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/guests/GuestVisitForm.vue